import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

export const AppointmentBlockContainer = styled.div<{
  top: number;
  left: number;
  width: number;
  height?: number;
  zIndex?: number;
}>`
  position: absolute;

  z-index: ${({ zIndex }) => zIndex ?? 1};
  transition: box-shadow ${Variables.durationStandardWeb} ${Variables.easeEasy};

  top: ${({ top }) => top + 1}px;
  left: ${({ left }) => left + 1}px; // Left margin
  ${({ height }) => (height ? `height: ${height - 3}px;` : "")};
  width: ${({ width }) => `${width - 4}px`}; // Right margin
  min-width: 30px;

  background-color: white;
  border-radius: ${Variables.radiusS};
  overflow: hidden;

  &:hover {
    box-shadow: ${Variables.shadowSizeDefault};
  }
`;
